import React, { memo } from 'react';
import Box from '@mui/material/Box';
import AccountMenu from './AccountMenu';
import HeaderBreadcrumb from './HeaderBreadcrumb';

interface AppHeaderProps {
  username: string;
  onLogout: () => void;
}

const AppHeader: React.FC<AppHeaderProps> = ({ username, onLogout }) => (
  <Box
    component="header"
    sx={{
      height: 64,
      flexShrink: 0,
      display: 'flex',
      alignItems: 'center',
      gap: 2,
      px: 3,
      position: 'sticky',
      top: 0,
      zIndex: (theme) => theme.zIndex.appBar,
      bgcolor: 'background.default',
      borderBottom: 1,
      borderColor: 'divider',
    }}
  >
    <HeaderBreadcrumb />
    <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <AccountMenu username={username} onLogout={onLogout} />
    </Box>
  </Box>
);

export default memo(AppHeader);
